import {
  Component,
  DoCheck,
  EventEmitter,
  Input,
  IterableDiffer,
  IterableDiffers,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';

import { SelectGridOption } from './select-grid.types';

@Component({
  selector: 'wfm-select-grid',
  templateUrl: './select-grid.component.html',
  styleUrls: ['./select-grid.component.scss']
})
export class SelectGridComponent implements DoCheck, OnChanges {
  @Input() options: SelectGridOption[] = [];

  @Input() label: string;

  @Input() columns = 1;

  @Input() columnsLabels: string[] = [];

  @Output() optionClick = new EventEmitter<SelectGridOption>();

  @Output() optionOver = new EventEmitter<SelectGridOption>();

  @Input() stopPropagation: boolean;

  grid: SelectGridOption[][] = [[]];

  private optionsDiffer: IterableDiffer<any>;
  private labelsDiffer: IterableDiffer<any>;

  constructor(iterableDiffers: IterableDiffers) {
    this.optionsDiffer = iterableDiffers.find([]).create();
    this.labelsDiffer = iterableDiffers.find([]).create();
  }

  ngDoCheck() {
    const optionsChanges = this.optionsDiffer.diff(this.options);
    const labelsChanges = this.labelsDiffer.diff(this.columnsLabels);

    if (optionsChanges || labelsChanges) {
      this.calculateGrid();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.columns && changes.columns.currentValue !== changes.columns.previousValue) {
      this.calculateGrid();
    }
  }

  private calculateGrid() {
    // if columnsLabels and columns are provided, use columnsLabels.length as the number of columns
    // if columns is not provided, use 1 as the number of columns
    let columns = (this.columnsLabels && this.columnsLabels.length) || this.columns;
    columns = (columns > 0 && columns) || 1;

    // copy options array
    const options = [...this.options];

    this.grid = options.reduce(
      (grid: SelectGridOption[][], option) => {
        let row = grid[grid.length - 1];
        if (row.length >= columns) {
          row = [];
          grid.push(row);
        }
        row.push(option);
        return grid;
      },
      [[]]
    );
  }

  click(option: SelectGridOption) {
    !option.disabled && this.optionClick.emit(option);
  }

  enter(option: SelectGridOption) {
    !option.disabled && this.optionOver.emit(option);
  }
}
